import { Component, computed, effect, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { EnvironmentBadge } from '@components/environment-badge/environment-badge';
import { ButtonModule } from 'primeng/button';

import { RETURN_URL_KEY } from '@core/guards/auth-guard';
import { AuthService } from '@core/services/auth';
import { SessionLostReason } from '@core/services/session-expiry';

@Component({
  selector: 'app-not-authorized',
  imports: [ButtonModule, EnvironmentBadge],
  templateUrl: './not-authorized.html',
  styleUrl: './not-authorized.scss'
})
export class NotAuthorized {
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);

  /** Bound from the `?reason=` query param — router component input binding is enabled. */
  readonly reason = input<string>();

  protected readonly isExpired = computed(() => this.reason() === SessionLostReason.Expired);

  constructor() {
    // A still-authenticated user has no business on the logged-out page.
    effect(() => {
      if (this.auth.isAuthenticated()) {
        this.router.navigate(['/dashboard']);
      }
    });
  }

  protected login(): void {
    this.auth.login(sessionStorage.getItem(RETURN_URL_KEY) ?? undefined);
  }
}
